module.exports = __webpack_public_path__ + "static/frog2-5aa5b2f8e49e85524ab112e37a761cef.png";